import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';

import Auth from '../../services/auth';
import { logout } from '../../store/ducks/auth';

export class Logout extends React.Component {
  componentDidMount() {
    const { dispatch } = this.props;

    Auth.removeToken();
    dispatch(logout());
  }

  render() {
    return (
      <div>
        <h1>
          <span id="title">You are currently logged out</span>
        </h1>

        <Button id="loginButton" variant="primary" size="sm" href="/launcher/login">LOG IN</Button>
      </div>
    );
  }
}

Logout.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default connect()(Logout);
